import { makeStyles } from "@material-ui/core";
import { ResponsiveBar } from '@nivo/bar';
import { DashboardHeader } from "pages/admin/dashboard/components/general";

const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)'
  },
  chart: {
    width: '100%',
    height: '100%',
  }
}));

const data = [
  {
    "key": "Aerospace Industry",
    "industry1": 50,
    "color": "#40B451"
  },
  {
    "key": "Automotive Industry",
    "industry2": 40,
    "color": "#50A2AF"
  },
  {
    "key": "Automation & Robotics",
    "industry3": 20,
    "color": "#23C0E1"
  },
  {
    "key": "Bioeconomy",
    "industry4": 15,
    "color": "#EDAD3D"
  },
  {
    "key": "Bio-plastics Industry",
    "industry5": 10,
    "color": "#EDCF47"
  },
]

const sum = 500;

const ResponsiveBarIndustry = ({ data /* see data tab */ }) => (
  <ResponsiveBar
    data={data}
    // keys={['industry']}
    keys={['industry1', 'industry2', 'industry3', 'industry4', 'industry5']}
    indexBy="key"
    margin={{ top: 20, right: 10, bottom: 20, left: 30 }}
    padding={0.3}
    valueScale={{ type: 'linear' }}
    indexScale={{ type: 'band', round: true }}
    borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
    axisTop={null}
    axisRight={null}
    colors={data.map(x => x.color)}

    // colors={['#40B451', '#50A2AF', '#23C0E1', '#EDAD3D', '#EDAD3D']}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: 'key',
      legendPosition: 'middle',
      legendOffset: 32,
      format: function (value) {

        if (value.length > 10) {
          var shortname = value.substring(0, 10) + " ...";
          return shortname
        }
        return value;
      }
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickValues: 6,
      tickRotation: 0,
      legend: 'food',
      legendPosition: 'middle',
      legendOffset: -40
    }}
    labelSkipWidth={10}
    labelSkipHeight={11}
    labelTextColor={{ from: 'color', modifiers: [['brighter', '1.8']] }}
    // legends={[]}
    role="application"
    isFocusable={true}
    label={d => {
      const percent = (d.value * 100 / sum).toFixed(2);
      const pertxt = `(${percent}%)`
      // console.log(d);
      // return (
      //   <>
      //     <tspan>{d.value}</tspan>
      //     <tspan>{pertxt}</tspan>
      //   </>
      // )

      return `${d.value}: ${pertxt}`
    }}

  />
)

function Industry() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="Top 5 target Industries" />
      </div>
      <div className={classes.wrapChart}>

        <ResponsiveBarIndustry data={data} className={classes.chart} />
      </div>
    </>
  )
}


export default Industry;